import { Link } from "react-router-dom";
import MobileContainer from "./Container";
import useUserStore from "../../stores/user";
import { E_USER_TIER } from "../../constants/common";

const MobileFooter = () => {
  const { user } = useUserStore();
  // Determine which Line contact to show
  const isNarinOnline =
    user &&
    user.userTierId >= E_USER_TIER.GROCERY &&
    user.userTierId <= E_USER_TIER.PHARMACY;
  const lineLink = isNarinOnline
    ? "https://line.me/ti/p/~@narinonline"
    : "https://line.me/ti/p/~@narinch";
  const lineText = isNarinOnline ? "@narinonline" : "@narinch";

  return (
    <div className="bg-[#5815B7] text-white">
      <div className="hidden md:block max-w-[1024px] mx-auto">
        <div className="h-[210px] grid grid-cols-4 py-4">
          <div className="flex flex-col justify-center items-center">
            <img src="/logo.png" width={80} height={80} />
            <div>บริษัท นรินทร์เภสัช จำกัด</div>
            <div>NARINONLINE</div>
          </div>
          <div className="flex flex-col justify-center gap-2 pl-4">
            <div className="text-secondary font-semibold">ช่องทางการติดต่อ</div>
            <div>
              <div>291 ถนนยุติธรรม ตำบลในเมือง</div>
              <div>อำเภอเมือง จังหวัดชัยภูมิ 36000</div>
            </div>
            <div>โทร. 088-886-8628</div>
          </div>
          <div className="flex flex-col justify-center gap-2 pl-4">
            <div className="text-secondary font-semibold">เปิดบริการ</div>
            <div>จันทร์ - เสาร์ เวลา 08:00 น. - 18:00 น.</div>
            <div className="text-secondary font-semibold">Social Media</div>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/narinbhaesaj"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="flex gap-2 items-center">
                  <img src="/facebook-icon.png" height={20} width={24} />
                  <div>narinbhaesaj</div>
                </div>
              </a>
              <a href={lineLink} target="_blank" rel="noopener noreferrer">
                <div className="flex gap-2 items-center">
                  <img src="/line-icon.png" height={20} width={24} />
                  <div>{lineText}</div>
                </div>
              </a>
            </div>
          </div>
          <div className="flex flex-col justify-center pl-4">
            <div className="text-secondary font-semibold">ข้อมูลร้านยา</div>
            <div>
              <Link to="/why-2-buy">
                <div className="hover:text-secondary">ทำไมต้องซื้อกับเรา</div>
              </Link>
              <Link to="/return-policy">
                <div className="hover:text-secondary">
                  เงื่อนไขการเปลี่ยนคืนสินค้า
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile layout for xs screens */}
      <div className="md:hidden">
        <MobileContainer>
          <div className="py-6 flex flex-col gap-5">
            <div className="flex flex-col items-start pl-4">
              <img src="/logo.png" width={70} height={70} />
              <div className="text-left">
                <div>บริษัท นรินทร์เภสัช จำกัด</div>
                <div>NARINONLINE</div>
              </div>
            </div>

            <div className="flex flex-col items-start gap-1 pl-4">
              <div className="text-secondary font-semibold">
                ช่องทางการติดต่อ
              </div>
              <div className="text-left">
                <div>291 ถนนยุติธรรม ตำบลในเมือง</div>
                <div>อำเภอเมือง จังหวัดชัยภูมิ 36000</div>
              </div>
              <div>โทร. 088-886-8628</div>
            </div>

            <div className="flex flex-col items-start gap-1 pl-4">
              <div className="text-secondary font-semibold">เปิดบริการ</div>
              <div className="text-left">
                จันทร์ - เสาร์ เวลา 08:00 น. - 18:00 น.
              </div>

              <div className="text-secondary font-semibold mt-2">
                Social Media
              </div>
              <div className="flex gap-4 justify-start">
                <a
                  href="https://www.facebook.com/narinbhaesaj"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex gap-2 items-center">
                    <img src="/facebook-icon.png" height={20} width={24} />
                    <div>narinbhaesaj</div>
                  </div>
                </a>
                <a href={lineLink} target="_blank" rel="noopener noreferrer">
                  <div className="flex gap-2 items-center">
                    <img src="/line-icon.png" height={20} width={24} />
                    <div>{lineText}</div>
                  </div>
                </a>
              </div>
            </div>

            <div className="flex flex-col items-start gap-1 pl-4">
              <div className="text-secondary font-semibold">ข้อมูลร้านยา</div>
              <div className="flex flex-col items-start">
                <Link to="/why-2-buy">
                  <div className="hover:text-secondary">ทำไมต้องซื้อกับเรา</div>
                </Link>
                <Link to="/return-policy">
                  <div className="hover:text-secondary">
                    เงื่อนไขการเปลี่ยนคืนสินค้า
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </MobileContainer>
      </div>

      <div className="h-[38px] bg-primary-500 flex items-center justify-center text-base">
        COPYRIGHT © 2025 NARINONLINE
      </div>
    </div>
  );
};

export default MobileFooter;
